import React from 'react'
import { Box } from '@mui/material'
import { AppBasicTable, AppLinksBlock } from '@components'
import { formatDate } from '@ui-seeker/utils'
import { dateFormatReceiver } from '@utils'
import { checkerColumn, statusColumn } from '../Table/columns'


function linksColumn() {
	return {
		name: 'status',
		render: (status, row) => {
			if (status !== 'ready') return null
			return <Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<AppLinksBlock
					reportExecutionID={row.id_report_execution}
					hasCompetitionSites
					dor={false}
					lor={false}
					downMultiReport={false}
					downMultiExport={false}
					isRating
				/>
			</Box>
		}
	}
}

function globalDownloadColumn() {
	return {
		name: 'status',
		render: (status, row) => {
			if (status !== 'ready') return null
			return <Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<AppLinksBlock
					reportExecutionID={row.id_report_execution}
					downMultiReport
					dor={false}
					lor={false}
					showHistory={false}
					isRating
				/>
			</Box>
		}
	}
}

function dateColumn() {
	return {
		name: 'timestamp_create_user',
		render: value => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
			{formatDate(value, {
				isString: true,
				format: 'dd MMM yyyy HH:mm',
				receivedFormat: dateFormatReceiver(value)
			})}
		</Box>
	}
}


export default function RatingHistoryTable({ reportName, data }) {
	return <AppBasicTable
		sx={{ maxHeight: 400, borderRadius: 1 }}
		title={`${reportName}'s Executions`}
		toolbarProps={{ actions: false }}
		data={data}
		headers={[[
			{ label: 'Date' },
			{ label: 'Status' },
			{ label: 'Mailed' },
			{ label: 'Opened' },
			{ label: 'Links' },
			{ label: 'Global Download' },
		]]}
		columns={[
			dateColumn(),
			statusColumn(),
			checkerColumn('mailed'),
			checkerColumn('opened'),
			linksColumn(),
			globalDownloadColumn(),
		]}
	/>
}